<template>
  <div class="flex-box">
    <v-form @submit.prevent="verifyOTP">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        "
      >
        <p
          style="text-align: center; width: 65%; line-height: 21px"
          v-if="userName"
        >
          An OTP has been sent to your email <b>{{ userName }}</b
          >. Please enter it to proceed.
        </p>
        <div v-if="!verifySuccess" flat class="card">
          <img style="width: 6rem" class="mb-3" alt="" />
          <div>
            <h3>Enter your OTP</h3>
            <p
              v-if="errorMessage && this.otp"
              style="color: red; font-size: 14px; text-align: center"
              class="mt-3"
            >
              {{ errorMessage }}
            </p>
            <div class="mt-4 mb-2">
              <v-text-field
                :rules="otpRule"
                placeholder="OTP"
                maxlength="6"
                type="password"
                outlined
                @keyup.enter="verifyOTP"
                v-model="otp"
              />
            </div>
            <div>
              <div
                v-if="this.timeLeft !== 0"
                style="font-size: 14px; color: gray; margin-top: 18px"
              >
                OTP expire in:
                <span style="color: #0068b3">
                  {{ Math.floor(timeLeft / 60) }}:{{
                    ("0" + (timeLeft % 60)).slice(-2)
                  }}</span
                >
              </div>
              <div
                v-if="this.timeLeft == 0"
                style="font-size: 14px; color: red"
              >
                OTP has expired. Please request a new one.
              </div>
            </div>
            <div align="start">
              <div class="forget" @click="sendOtp">Resent OTP ?</div>
            </div>
            <div>
              <v-btn
                color="#2b2f8e"
                block
                style="color: white; margin-top: 20px"
                size="large"
                type="submit"
                :loading="loading"
                class="text-none log-btn text-white mb-4"
                >Verify</v-btn
              >
            </div>
          </div>
        </div>
      </div>
      <div class="log-text" v-if="!verifySuccess">
        If you have trouble signing in please contact administrator
      </div>
    </v-form>
  </div>
</template>
<script>
import OtpService from "../OtpService";
export default {
  data() {
    return {
      token: null,
      error: null,
      userNotFount: false,
      loading: false,
      userName: null,
      showOtp: false,
      verifySuccess: false,
      errorMessage: null,
      sessionInfo: null,
      redirecturl: null,
      otpRule: [(value) => !!value || "OTP  is Required."],
      otp: null,
      host: "",
      timeLeft: 300,
      timer: null,
    };
  },
  // async created() {
  //   await this.sendOtp();
  //   this.token = this.$route.query.token;
  //   this.userName = this.$route.query.email;
  // },
  watch: {
    otp(newVal) {
      if (newVal === "") {
        this.errorMessage = null;
      }
    },
  },
  mounted: async function () {
    this.token = this.$route.query.token;
    this.userName = this.$route.query.email;
    try {
      await this.sendOtp();
    } catch (error) {
      console.error("OTP sending failed:", error);
    }
  },
  methods: {
    startTimer() {
      this.timeLeft = 300;
      if (this.timer) clearInterval(this.timer);

      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async verifyOTP() {
      if (this.otp) {
        try {
          this.loading = true;
          this.errorMessage = "";
          this.error = "";
          let response = await OtpService.verifyOtp({
            otp: this.otp,
            email: this.userName,
          });
          if (response.message == "OTP verified successfully") {
            try {
              this.loading = false;
              this.$router.push(`/logincompany?token=${this.token}`);
            } catch (e) {
              console.log(e, "error");
            }
          } else {
            this.errorMessage = response.message;
            this.loading = false;
          }
        } catch (e) {
          console.log(e, "error2");
          (this.error = e.message), (this.loading = false);
        }
      }
    },

    // async sendEmail() {
    //   try {
    //     this.loading = true;
    //     let data = {
    //       host: window.location.origin,
    //       email: this.email,
    //       appId: localStorage.getItem("APP_ID"),
    //       redirectUrl: localStorage.getItem("REDIRECT_URL"),
    //     };
    //     localStorage.setItem("PASSWORD_DATA", JSON.stringify(data));
    //     let response = await ResetPasswordService.forgotPassword(data);
    //     console.log(response, "hhhhhhhhh");
    //     if (response.message == "User not found in firebase") {
    //       this.userNotFount = true;
    //       this.loading = false;
    //     } else {
    //       this.$router.push({
    //         path: "/checkemail",
    //         query: { email: this.email, host: window.location.origin },
    //       });
    //     }
    //   } catch (e) {
    //     this.loading = false;
    //     console.log(e);
    //   }
    // },

    async sendOtp() {
      if (this.token && this.userName) {
        let response = await OtpService.sendOtp({
          email: this.userName,
        });
        this.startTimer();
      } else {
        window.location = process.env.VUE_APP_ONEAPP_DOMAIN;
      }
    },
  },
};
</script>
<style>
.flex-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}
.flex-box .back {
  cursor: pointer;
}
.flex-box .back:hover {
  color: rgb(104, 104, 246);
  cursor: pointer;
}
.flex-box .card {
  width: 300px !important;
  box-shadow: 0 0 6px #00000038;
  padding: 10px 20px;
}
.flex-box .lable {
  margin-top: 30px;
}
.flex-box .forget {
  cursor: pointer;
  margin-top: 20px;
  font-size: 14px;
  color: blue;
}
.log-text {
  text-align: center;
  margin-top: 40px;
}
</style>
